var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepairMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H87.5L100 12.5V100H0V0Z",
    fill: "#FF3366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8584 45.95L74.654 51.675L80 37.5L62.2883 20L52.5207 29.725L59.0907 36.225L50.797 44.325L46.5252 40C47.1996 37.8002 47.2678 35.4589 46.7226 33.2234C46.1773 30.988 45.0389 28.9415 43.4275 27.3C41.5318 25.502 39.147 24.3053 36.5733 23.8605C33.9996 23.4157 31.3519 23.7425 28.9634 24.8L25.7658 26.125L34.1595 34.375L33.2851 36.875L30.787 37.75L22.5432 29.325L21.1443 32.5C20.0787 34.8592 19.7471 37.4847 20.1926 40.035C20.6381 42.5854 21.8402 44.9426 23.6424 46.8C25.3331 48.4229 27.4279 49.562 29.7084 50.0985C31.989 50.635 34.3716 50.5492 36.6076 49.85L67.2096 80L77.0522 70.275L60.6396 54.05L68.8584 45.95ZM62.2883 26.475L74.6041 38.65L72.8304 43.4L72.1309 42.7L68.5586 39.175L59.0158 29.725L62.2883 26.475ZM62.2883 39.45L65.5609 42.7L57.367 50.8L54.0695 47.5L62.2883 39.45ZM70.4822 70.275L67.2096 73.525L37.8067 44.475L36.3828 45C34.8419 45.6914 33.1316 45.913 31.4655 45.6374C29.7994 45.3617 28.2514 44.6009 27.0149 43.45C25.5565 42.0083 24.7222 40.0512 24.6916 38L29.6879 43L36.9074 40.5L39.4055 33.375L34.4093 28.375C36.4928 28.3489 38.5061 29.128 40.0301 30.55C41.1973 31.7511 41.9727 33.2785 42.2537 34.9302C42.5347 36.5819 42.3081 38.28 41.6039 39.8L41.0043 41.225L52.0211 52.125L57.2671 57.3L70.4822 70.275Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3836 73.525L31.1111 70.275L42.6024 58.925L39.3049 55.675L24.541 70.275L34.3836 80L49.1475 65.4L45.875 62.15L34.3836 73.525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairMini);
export default __webpack_public_path__ + "static/media/repair_mini.32c2d77bfa48f4cf1b5465c8cddb88ea.svg";
export { ForwardRef as ReactComponent };